export default __webpack_public_path__ + "static/media/Artboard 1 copy 13@2x 1.619f7f7b.svg";